const formats = [
  {
    icon: 'ri-calendar-check-line',
    title: 'Корпоративный тренинг',
    desc: 'Практическая программа на 1–2 дня. Интенсивная работа с управленческой командой: алгоритмы постановки задач, отработка делегирования, контрольных разговоров.',
  },
  {
    icon: 'ri-stack-line',
    title: 'Модульная программа',
    desc: 'Несколько встреч с практикой между модулями. Участники внедряют инструменты в работу и возвращаются с реальными кейсами для разбора.',
  },
  {
    icon: 'ri-vip-crown-line',
    title: 'Управленческая программа',
    desc: 'Комплексное развитие руководителей в течение нескольких месяцев. Охватывает делегирование, постановку задач, контроль, обратную связь и другие компетенции.',
  },
  {
    icon: 'ri-gamepad-line',
    title: 'Бизнес-игры',
    desc: 'Практическая отработка управленческих ситуаций в игровом формате. Высокая вовлечённость и возможность увидеть свои управленческие привычки со стороны.',
  },
  {
    icon: 'ri-user-voice-line',
    title: 'Коучинг руководителей',
    desc: 'Индивидуальная работа с конкретными управленческими задачами: как делегировать конкретному сотруднику, как выстроить систему контроля в отделе.',
  },
  {
    icon: 'ri-phone-line',
    title: 'Сопровождение',
    desc: 'Разбор реальных ситуаций после обучения: поддержка внедрения, ответы на вопросы, корректировка подхода к конкретным сотрудникам и задачам.',
  },
];

export default function FormatsSection() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Форматы обучения
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-4 max-w-3xl mx-auto leading-relaxed">
          Конкретный формат определяется после обсуждения задачи компании
        </p>
        <p className="text-sm text-gray-500 text-center mb-12 max-w-2xl mx-auto">
          Мы не предлагаем шаблонное решение. Сначала разбираемся в ситуации и только потом предлагаем подходящий формат.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {formats.map((f) => (
            <div key={f.title} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${f.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{f.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}